import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "hooks/redux";
import { ISlot, ITeeTimeSlotNew } from "redux/reducers/models/teetime";
import { displayTurnTime, getGroupPaceTimes } from "elements/teesheet/paceTracker/paceTrackerUtils";
import "elements/teesheet/paceTracker/paceTracker.scss";

interface IPaceTrackerContextInfoProps {
  slots: Array<ITeeTimeSlotNew | ISlot>;
}

function formatPaceLine(time: string, t: (key: string) => string): string {
  if (!time) {
    return t("Not recorded");
  }
  return `${t("Recorded at")} ${moment.utc(time, "YYYY-MM-DD HH:mm")?.local()?.format("LT")}`;
}

export default function PaceTrackerContextInfo(props: IPaceTrackerContextInfoProps) {
  const { slots } = props;
  const { t } = useTranslation();
  const { facilityStore } = useAppSelector(store => store);

  const { teeOffTime, turnTime, finishTime } = getGroupPaceTimes(slots ?? []);
  const showTurn = displayTurnTime(facilityStore?.facility?.holes ?? 18);

  return (
    <div className="pace-tracker-context-info">
      <p className="pace-tracker-context-info-title">{t("Pace Tracker")}</p>
      <p className="pace-tracker-context-info-line">
        {t("Tee Off")}: {formatPaceLine(teeOffTime, t)}
      </p>
      {showTurn ? (
        <p className="pace-tracker-context-info-line">
          {t("Turn")}: {formatPaceLine(turnTime, t)}
        </p>
      ) : null}
      <p className="pace-tracker-context-info-line">
        {t("Finish")}: {formatPaceLine(finishTime, t)}
      </p>
    </div>
  );
}
